export default __webpack_public_path__ + "static/media/Bracers of Infernal Zeal.d97f2bb9.jpg";